import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "5", y2: "19", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "5", x2: "19", y1: "12", y2: "12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Plus";
const Plus = memo(themed(Icon));
export {
  Plus
};
//# sourceMappingURL=plus.js.map
